<p-sidebar [(visible)]="isOpen" (onHide)="onSidebarHide()" position="right" [modal]="false" >
   <ng-container #host></ng-container>
</p-sidebar>
